import { useState, useEffect } from "react";
import Services from "../../shared/components/common/Services";
import Header from "../../shared/components/common/Header";
import ContactCTA from "../../shared/components/common/ContactCTA";
import MapAndCards from "../../shared/components/common/MapAndCards";
import BlogArticles from "../institucional/blog/BlogArticles";
import ContactDrawer from "../../shared/components/common/ContactDrawer";
import { useTheme } from "../../shared/contexts/ThemeContext";
import domains from "../../shared/config/domains";
import Web from "../../shared/img/banner/hero/respiratorio/Web.jpg"
import Tablet from "../../shared/img/banner/hero/respiratorio/tablet.jpg";
import Mobile from "../../shared/img/banner/hero/respiratorio/Mobile.jpg";

export default function Home() {
  const { thema } = useTheme();
  // Textos
  const textTitleHero = [
    "Equipamentos Respiratórios",
    "Home Care",
    "Equipamentos Auditivos",
  ];

  const textSubTitleHero = [
    "Noites de sono melhores proporcionam dias melhores.",
    "Confiança, amor e tratamento humanizado.",
    "Comprometimento, transparência e qualidade.",
  ];

  const textDescriptionHero = [
    "Os melhores equipamentos utilizados no tratamento de doenças respiratórias. Respirar bem é fundamental para nossa qualidade de vida.",
    "Nossa especialidade é em atendimento domiciliar a pacientes com conforto e segurança.",
    "Oferecemos as melhores soluções e produtos auditivos para seu bem-estar.",
  ];

  const buttonHero = ["Confira", "Confira", "Confira"];

  const buttonActionHero = [
    domains.respiratorio,
    domains.homecare,
    domains.auditivo,
  ];

  const [indice, setIndice] = useState(0);
  const totalHeroItems = textTitleHero.length;

  const getNextIndex = (currentIndex) => {
    return (currentIndex + 1) % totalHeroItems;
  };

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setIndice((currentIndex) => getNextIndex(currentIndex));
    }, 4000);

    return () => window.clearInterval(intervalId);
  }, [totalHeroItems]);

  return (
    <div className="bg-slate-100 min-h-screen">
      <h1 className="hidden">Bianco Azure</h1>

      {/* Header */}
      <Header />

      {/* HERO SECTION */}
      <section className="relative w-full h-[560px] md:h-[700px] lg:h-[800px] flex items-end justify-center px-4 overflow-visible">
        <div
          className="absolute inset-0 hidden lg:block bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${Web})` }}
        />

        <div
          className="absolute inset-0 hidden md:block lg:hidden bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${Tablet})` }}
        />

        <div
          className="absolute inset-0 block md:hidden bg-cover bg-top bg-no-repeat"
          style={{ backgroundImage: `url(${Mobile})` }}
        />

        <div className="absolute inset-0 bg-black/10" />
        <div className="absolute inset-0 pointer-events-none" />

        <div className="relative z-10 max-w-5xl w-[92%] mx-auto flex flex-col md:flex-row items-center justify-between bg-white/90 backdrop-blur-md p-4 md:p-6 rounded-2xl shadow-xl transform translate-y-[110%] md:translate-y-1/2">
          <div className="flex-1 px-2 text-center md:text-left">
            <p className="text-lg md:text-2xl font-bold text-[#004452]">
              {textTitleHero[indice]}
            </p>
            <p className="text-sm text-[#3a5156] mt-1">
              {textSubTitleHero[indice]}
            </p>
          </div>

          <p className="hidden md:block text-gray-600 text-sm flex-1 md:mx-4">
            {textDescriptionHero[indice]}
          </p>

          <div className="flex items-center gap-3 mt-4 md:mt-0">
            <a
              href={buttonActionHero[indice]}
              className="bg-black text-white pr-2 pl-5 py-2 rounded-full shadow-lg hover:bg-gray-800 transition-colors flex items-center gap-2"
            >
              {buttonHero[indice]}
              <div className="flex items-center justify-center w-8 h-8 rounded-full bg-white text-black">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 transform -rotate-45" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </div>
            </a>
          </div>
        </div>
      </section>

      {/* resto da página */}
      <div className="pt-24 md:pt-28">
        <Services />
      </div>
      <BlogArticles />
      <ContactCTA />
      <MapAndCards />

      <ContactDrawer message="Vim do site, queria saber mais sobre a Bianco Azure" />
    </div>
  );
}
